import React from 'react';
import type { Transaction } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { TransactionInvoiceCard } from '../Card/TransactionInvoiceCard';

export interface TransactionInvoicesTabProps {
  transaction: Transaction;
}

export function TransactionInvoicesTab({ transaction }: TransactionInvoicesTabProps) {
  const { t } = useTranslation(['m-payment']);

  const invoices = transaction.invoices ?? [];

  if (invoices.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-sm text-muted-foreground">
        {t('m-payment:transaction.drawer.invoices.no_invoices')}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 p-4">
      {invoices.map((inv, index) => (
        <TransactionInvoiceCard
          key={inv._id?.toString() || index}
          invoice={inv}
          currency={transaction.currency}
        />
      ))}
    </div>
  );
}
